module.exports = __webpack_public_path__ + "img/Om-norsk-Sprogreformation_Bilde-av-Amalie-Sofie-Bekkevold.2d430e7e.jpg";